





























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ChatMessage from '@/models/ChatMessage';
import { mapGetters } from 'vuex';
import { SendPacket } from '../../networking/SendPacket';
import { PacketType } from '../../models/Packet';

@Component({
    components: {
		
    },
    computed: {
        ...mapGetters([
            'checkProjectModerate'
        ])
    }
})
export default class ChatChannel extends Vue 
{
	@Prop(ChatMessage) readonly message!: ChatMessage;
	hovered = false;
	get isLocalUser()
	{
	    // Leaving senderId null for old entries
	    return (this.message.senderId && this.message.senderId == this.user.userid) || this.message.sender == this.user.username;
	}

	get bgColor()
	{
	    if (this.isLocalUser)
	    {
	        return `background-color: #396aba; color: white;`;
	    }
	    else
	    {
	        return `background-color: #cbd4e4;`;
	    }
	}

	deleteMessage()
	{
	    SendPacket(PacketType.DeleteChat, {
	        messageid: this.message.messageid
	    });
	}
}
